import React, { useState } from "react";
import { Card, Row, Col, Dropdown } from "react-bootstrap";
import Chart from "react-apexcharts";
import { FiCalendar } from "react-icons/fi";

export default function UserAccessManagement() {
  const [filter, setFilter] = useState("Today");

  const data = [
    { time: "9 AM", val: 85 },
    { time: "10 AM", val: 92 },
    { time: "11 AM", val: 78 },
    { time: "12 AM", val: 45 },
    { time: "1 AM", val: 38 },
    { time: "2 AM", val: 68 },
    { time: "3 AM", val: 82 },
    { time: "4 AM", val: 85 },
    { time: "5 AM", val: 88 },
    { time: "6 AM", val: 52 },
  ];

  const getColor = (v) => {
    if (v <= 50) return "#22c55e";
    if (v <= 70) return "#fbbf24";
    if (v <= 90) return "#f97316";
    return "#dc2626";
  };

  // 🔥 EXACT ORIGINAL GRAPH
  const chartOptions = {
    chart: {
      type: "area",
      toolbar: { show: false },
      zoom: { enabled: false },
    },

    stroke: {
      curve: "smooth", // 🔥 FIXED
      width: 2,
      colors: ["#f97316"],
    },

    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0,
        opacityFrom: 0.25,
        opacityTo: 0.05,
        stops: [0, 100],
      },
    },

    markers: {
      size: 4,
      colors: ["#3b82f6"],
      strokeWidth: 2,
      strokeColors: "#fff",
      hover: { size: 6 },
    },

    tooltip: {
      enabled: true,
      theme: "light",
    },

    grid: {
      borderColor: "#e5e7eb",
      strokeDashArray: 4,
    },

    xaxis: {
      categories: [
        "10:00 AM","11:00 AM","12:00 PM","01:00 PM",
        "02:00 PM","03:00 PM","04:00 PM","05:00 PM",
        "06:00 PM","07:00 PM","08:00 PM",
      ],
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        style: {
          fontSize: "12px",
          colors: "#6b7280",
        },
      },
    },

    yaxis: {
      labels: {
        style: {
          colors: "#9ca3af",
        },
      },
    },
  };

  const chartSeries = [
    {
      name: "Logins",
      data: [
        650,580,720,590,740,620,780,640,800,
        610,790,600,820,620,800,610,830
      ],
    },
  ];

  return (
    <>
      <style>{`
        .uam-card {
          border: 2px solid #e5e7eb;
          border-radius: 5px;
        }

        .peak-card {
          border: 1px solid #e5e7eb;
          border-radius: 10px;
          padding: 14px;
          background: #fff;
        }

        .progress {
          height: 6px;
          background: #e5e7eb;
          border-radius: 10px;
        }

        .progress-bar {
          border-radius: 10px;
          background-image: repeating-linear-gradient(
            45deg,
            rgba(255,255,255,0.2),
            rgba(255,255,255,0.2) 10px,
            transparent 10px,
            transparent 20px
          );
        }

        @media (max-width: 1024px) {
          .uam-card {
            margin-top: 15px;
          }
        }
      `}</style>

      <Card className="uam-card">
        <Card.Body>

          {/* HEADER */}
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
            <strong  style={{fontWeight:"650",fontSize:"20"}} >User Access & Role Management</strong>

            <Dropdown>
              <Dropdown.Toggle className="btn btn-light">
                <FiCalendar /> {filter}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {["Today","Weekly","Monthly"].map((f)=>(
                  <Dropdown.Item key={f} onClick={()=>setFilter(f)}>
                    {f}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* LEGEND */}
          <div className="d-flex justify-content-between flex-wrap mb-3">
            <strong style={{fontWeight:"650",fontSize:"20"}} >Peak Hours ({filter})</strong>

            <div className="d-flex gap-3 flex-wrap small">
              <span><span style={{color:"#f97316"}}>●</span> Low</span>
              <span><span style={{color:"#22c55e"}}>●</span> Medium</span>
              <span><span style={{color:"#fbbf24"}}>●</span> High</span>
              <span><span style={{color:"#dc2626"}}>●</span> Peak</span>
            </div>
          </div>

          {/* PEAK CARDS */}
          <Row className="g-3 mb-4">
            {data.map((d,i)=>(
              <Col key={i} xs={12} sm={6} md={4} lg={2}>
                <div className="peak-card">
                  <div className="d-flex justify-content-between">
                    <span>{d.time}</span>
                    <span style={{color:getColor(d.val)}}>●</span>
                  </div>

                  <h6 className="fw-bold mt-2">{d.val}%</h6>

                  <div className="progress mt-2">
                    <div
                      className="progress-bar"
                      style={{
                        width:`${d.val}%`,
                        backgroundColor:getColor(d.val)
                      }}
                    />
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* GRAPH */}
          <h6 className="fw-semibold mb-3">Login Count Analysis</h6>

          <Chart
            options={chartOptions}
            series={chartSeries}
            type="area"
            height={260}
          />

        </Card.Body>
      </Card>
    </>
  );
}